module.exports = new __parcel__URL__("minimize.2c88753d.svg").toString();